import { z } from 'zod';

import { generationStatusSchema } from './session-note.models';

export const noteGeneratorProgressNotificationSchema = z.object({
    type: z.literal('note-generator/progress'),
    payload: z.object({
        sessionId: z.string(),
        noteId: z.string(),
        noteGeneratorStatus: generationStatusSchema,
        errorType: z.string().optional(),
    }),
});
